<div class="adx-lib-widget-setting-wrapper">
    <div class="adx-settings-dialog">
        <div class="adx-settings-header">
            <h2 class="adx-settings-title">
                {{ "ASTIMAX.CONTACT.WIDGET.CONTACTS" | translate }} {{ "ASTIMAX.CONTACT.WIDGET.SETTINGS" | translate }}
            </h2>
            <button mat-icon-button
                    [mat-dialog-close]="true"
                    aria-label="Close Button"
                    class="adx-settings-close-btn"
                    matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CLOSE' | translate }}">
                <fa-icon [icon]="'xmark'"></fa-icon>
            </button>
        </div>

        <div class="adx-settings-content">
            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "ASTIMAX.CONTACT.WIDGET.WIDGET_TITLE" | translate }}</mat-label>
                    <input matInput
                           aria-label="Titel eingeben"
                           type="text"
                           [(ngModel)]="widgetTitle"
                           minlength="2"
                           maxlength="50">
                </mat-form-field>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ 'ASTIMAX.CONTACT.WIDGET.WIDGET_HEADER_DISPLAY_OPTIONS' | translate }}</mat-label>
                    <mat-select [(value)]="selectedWidgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
                        @for (option of (contactWidget.settings.widgetHeader | keyvalue); track option.key) {
                            <mat-option [value]="option.key" [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
                                {{ getText(option.key) | translate }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="adx-form-row adx-toggle-row">
                <mat-slide-toggle class="primary" [(ngModel)]="showWidgetTitle">
                    <span class="adx-toggle-label">{{ 'ASTIMAX.CONTACT.WIDGET.SHOW_WIDGET_TITLE' | translate }}</span>
                </mat-slide-toggle>
            </div>
        </div>

        <div class="adx-settings-footer">
            <button mat-raised-button
                    type="button"
                    [mat-dialog-close]="true"
                    aria-label="Bearbeitung abbrechen"
                    matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CANCEL_EDITING' | translate }}">
                {{ "ASTIMAX.CONTACT.WIDGET.CANCEL" | translate }}
            </button>
            <button mat-raised-button
                    class="primary"
                    type="submit"
                    (click)="onSubmit()"
                    matTooltip="{{'ASTIMAX.CONTACT.WIDGET.SAVING_CHANGES' | translate }}">
                {{ "ASTIMAX.CONTACT.WIDGET.SAVE" | translate }}
            </button>
        </div>
    </div>
</div>
